import React from "react";
import style from "css/admin/component.module.css";

function SearchItem({ label, children, className = "", ...rest }) {
    return (
        <div className={`${style.searchItem} ${className}`} {...rest}>
            <div className={`${style.searchItem_label} ${!label ? style.searchItem_label_hidden : ""}`}>
                {label || "\u00A0"}
            </div>
            <div className={style.searchItem_component}>{children}</div>
        </div>
    );
}

export default SearchItem;

